import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=d44a47e2&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44a47e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d44a47e2')) {
      api.createRecord('d44a47e2', component.options)
    } else {
      api.reload('d44a47e2', component.options)
    }
    module.hot.accept("./Tabs.vue?vue&type=template&id=d44a47e2&scoped=true", function () {
      api.rerender('d44a47e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tabs/Tabs.vue"
export default component.exports